const actions = {
  GET_DATA_BRANCH: 'GET_DATA_BRANCH',
  SET_DATA_BRANCH: 'SET_DATA_BRANCH',
  EDIT_DATA_BRANCH: 'EDIT_DATA_BRANCH',
  DELETE_DATA_BRANCH: 'DELETE_DATA_BRANCH',
  GET_DATA_FINISH: 'GET_DATA_FINISH',
  GET_DATA_BEGIN: 'GET_DATA_BEGIN',
  //NEW
  SET_NEW_DATA_BRANCH: 'SET_NEW_DATA_BRANCH',
  getBranchData: () => {
    return {
      type: actions.GET_DATA_BRANCH,
    };
  },
  setBranchData: (data: any) => {
    return {
      type: actions.SET_DATA_BRANCH,
      data,
    };
  },
  getDataBegin: () => {
    return {
      type: actions.GET_DATA_BEGIN,
    };
  },
  getDataFinish: () => {
    return {
      type: actions.GET_DATA_FINISH,
    };
  },
  setDeleteBranch: (data: any) => {
    return {
      type: actions.DELETE_DATA_BRANCH,
      data,
    };
  },
  setEditBranchData: (data: any) => {
    return {
      type: actions.EDIT_DATA_BRANCH,
      data,
    };
  },
  setNewBranchData: (data: any) => {
    return {
      type: actions.SET_NEW_DATA_BRANCH,
      data,
    };
  },
};


export default actions;
